import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap, tap } from "rxjs/operators";
import { ConfigService } from "../../../config/config.service";
import { Client } from "../../shared/client/client";
import { ExportBordereaux } from "./bordereaux";

@Injectable({
  providedIn: 'root'
})
export class BordereauxService {

  /**
   * @param {HttpClient} http
   * @param {ConfigService} configService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
  }

  getBordereaux(client: Client): Observable<Array<ExportBordereaux>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<ExportBordereaux>>(config.apiPoint + config.getBordereaux.replace("{client}", client.id));
      }));
  }

  downloadBordereaux(bordereau, transform) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.downloadBordereaux.replace("{bordereau}", bordereau.id), {
          params: {
            transform: transform
          },
          responseType: 'arraybuffer'
        }).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/pdf' });
            let filename = bordereau.nom_fichier;
            if (transform) {
              if (bordereau.type === "MAD") {
                filename = filename.replace("mise-a-disposition", "mise-en-place");
              } else {
                filename = filename.replace("mise-en-place", "mise-a-disposition");
              }
            }
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
        );
      }));
  }

  getDelayBordereaux() {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Number>(config.apiPoint + config.getDelayBordereaux);
      }));
  }
}
